// Used by useQueryParamsManager only
import { useCallback } from "react";
// eslint-disable-next-line no-restricted-imports
import { useNavigate as useReactRouterNavigate } from "react-router-dom";

export type QueryParamNavOptions = { replace?: boolean };

export const useMockableNavigate = () => {
  const navigate = useReactRouterNavigate();

  return useCallback(
    (params: URLSearchParams, location: Location, options?: QueryParamNavOptions) => {
      const url = new URL(location.href);
      url.search = params.toString();

      const next = `${url.pathname}${url.search}${url.hash}`;
      const current = `${location.pathname}${location.search}${location.hash}`;

      if (next !== current) {
        // Query param updates are almost always "state sync", not user navigation.
        // Default to replace to avoid polluting / breaking the browser Back stack.
        navigate(next, { replace: options?.replace ?? true });
      }
    },
    [navigate],
  );
};
